export default __webpack_public_path__ + "static/media/bg_banner_servicios03.30c62ef0.png";